import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/wissen/mentorings")({
  component: () => <Outlet />,
});
